import { WorkflowAdditionalOptionsSubBaseService } from "app/core/workflow/workflow-steps/applicant/sub/workflow-additional-options-sub-base.service";

export class WorkflowAdditionalOptionsOneService extends WorkflowAdditionalOptionsSubBaseService {
  public get subStepNumber(): number {
    return 2;
  }
}
